import { useEffect, useState } from 'react';
import BaseService from '../../../services/BaseService';
import { INSPECAO_MT_BT_TIPO_SERVICO_ID } from '../../../utils';

const mapOptions = (data) =>
  (data || []).map((item) => ({
    id: String(item.id),
    label: item.value,
    parentId: item.parentId != null && item.parentId !== '' ? String(item.parentId) : null,
  }));

export const useNsirMapaFilterOptions = () => {
  const [tipoServicoOptions, setTipoServicoOptions] = useState([]);
  const [subtipoOptions, setSubtipoOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadOptions = async () => {
      setLoading(true);
      try {
        const [tipoResponse, subtipoResponse] = await Promise.all([
          BaseService.get({ url: 'options/TIPO_SERVICO' }),
          BaseService.get({ url: 'options/NSIR_SUBTIPOS' }),
        ]);

        if (cancelled) return;

        setTipoServicoOptions(mapOptions(tipoResponse.data));
        setSubtipoOptions(mapOptions(subtipoResponse.data));
      } catch (error) {
        console.error(error);
        if (!cancelled) {
          setTipoServicoOptions([]);
          setSubtipoOptions([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadOptions();

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    tipoServicoOptions,
    subtipoOptions,
    mtBtTipoServicoId: INSPECAO_MT_BT_TIPO_SERVICO_ID,
    loading,
  };
};
